import React from 'react';
import PropTypes from 'prop-types';

const ConfirmCheckoutDate = ({ confirm, showTime = true, entryTimeLabel = null }) => {
  const doorAndShow = showTime && !entryTimeLabel ? confirm.human_door_and_show_times : null;
  const dateText = showTime && !doorAndShow
    ? confirm.human_date_and_time_with_day_of_week
    : confirm.human_date_with_day_of_week;

  return (
    <>
      {dateText ? (
        <p className="mb-1" style={{ color: "var(--widget-secondary-text-color, #686868)" }}>
          {dateText}
        </p>
      ) : null}
      {doorAndShow ? (
        <p className="mb-1" style={{ color: "var(--widget-secondary-text-color, #686868)" }}>
          {doorAndShow}
        </p>
      ) : null}
      {entryTimeLabel ? (
        <p className="mb-1 text-dark" style={{ fontWeight: 600 }}>
          Entry at {entryTimeLabel}
        </p>
      ) : null}
    </>
  );
};

ConfirmCheckoutDate.propTypes = {
  confirm: PropTypes.object.isRequired,
  showTime: PropTypes.bool,
  entryTimeLabel: PropTypes.string
};

export default ConfirmCheckoutDate;
